export default function normalizeChartParams({
  packageName,
  app,
  selectedFilters: { primaryType, secondaryType, range },
}) {
  const params = {
    range,
    packageName,
  };

  const { type, child, tag } = primaryType;
  params.stat_type = type;
  params.child = child;
  if (tag) {
    params.tag = tag;
  }

  if (secondaryType.type) {
    const { type: typeS, child: childS, tag: tagS } = secondaryType;
    params.secondary_stat_type = typeS;
    params.secondary_child = childS;
    if (tagS) {
      params.secondary_tag = tagS;
    }
  }
  const { haveIap } = app;
  if (haveIap) {
    params.is_in_app = 1;
  }
  return params;
}
